var angular = require('angular');
var _module = require('./index');

require('../lr-touch');

_module.requires.push('lr.touch');


_module.directive('slickGalleryItemClicked', [
    '$lrTap',
    '$parse',

    function($lrTap, $parse) {
        return {
            restrict: 'A',
            link: function($scope, elem, attrs) {
                $lrTap(elem, '.slick-slide')
                    .on('tap', function(e, target) {
                        var index = Number(angular.element(target).attr('data-slick-index'));
                        $scope.$apply(function() {
                            $parse(attrs.slickGalleryItemClicked)($scope.$parent, { '$index': index });
                        });
                    })
                ;
            }
        };
    }
]);
